import { forwardRef } from 'react';

/**
 * HudButton — bouton standard cockpit.
 * variant: 'primary' (gold), 'secondary' (surface), 'ghost', 'danger'
 * size:    'sm' | 'md' (default) | 'lg'
 * iconOnly: bool — bouton carré pour icônes
 */
const HudButton = forwardRef(function HudButton(
  { variant = 'primary', size = 'md', iconOnly = false, leftIcon, rightIcon,
    className = '', children, ...rest },
  ref
) {
  const cls = [
    'hud-btn',
    `hud-btn-${variant}`,
    `hud-btn-${size}`,
    iconOnly ? 'aspect-square px-0' : '',
    className,
  ].filter(Boolean).join(' ');

  const iconSize = size === 'sm' ? 14 : size === 'lg' ? 18 : 16;

  return (
    <button ref={ref} className={cls} {...rest}>
      {leftIcon && <span className="inline-flex shrink-0" style={{ width: iconSize, height: iconSize }}>{leftIcon}</span>}
      {children}
      {rightIcon && <span className="inline-flex shrink-0" style={{ width: iconSize, height: iconSize }}>{rightIcon}</span>}
    </button>
  );
});

export default HudButton;
export { HudButton };
